import { StatusEnum } from "../constants/employeeStatusEnum";
const StatusOptions = [
  { value: StatusEnum.ACTIVE, label: "Active" },
  { value: StatusEnum.INACTIVE, label: "Inactive" },
  { value: StatusEnum.DEALLOCATED, label: "Deallocated" },
];
export default StatusOptions;
